/**
 * @file BarPercentCell.tsx
 * @description cellType = BarPercent — 仅条形条件格式背景，文字不做数值上色/图标。
 *
 * DOM 结构：
 *   .dbl-table-bar-percent
 *     .dbl-table-bar-percent-fill → .dbl-table-bar-percent-fill-bar（width% + 背景色）
 *     .dbl-table-bar-percent-label → 纯 text
 */

import React, { useMemo } from 'react';
import { IAliTableCellComponentProps } from '@customComp/AliTableAnalytics/types';
import { resolveBarPercentPresentation } from '@customComp/AliTableAnalytics/utils/barPercentPresentation';

const BarPercentCell: React.FC<IAliTableCellComponentProps> = props => {
  const { text, row, column } = props || {};
  const { safePercent, backgroundColor, showPlainTextOnly } = useMemo(
    () => resolveBarPercentPresentation(row, column),
    [row, column],
  );

  /** 交叉表 allowList 未命中：不画条，与历史 BarPercent 行为一致 */
  if (showPlainTextOnly) {
    return <>{text}</>;
  }

  return (
    <div className="dbl-table-bar-percent">
      <div className="dbl-table-bar-percent-fill">
        <div
          className="dbl-table-bar-percent-fill-bar"
          style={{ width: `${safePercent}%`, backgroundColor }}
        />
      </div>
      <div className="dbl-table-bar-percent-label">{text}</div>
    </div>
  );
};

export default BarPercentCell;
